import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import AddQuizeComponents from "../../components/AdminPortal/Quizzes/AddQuize";

export default function AddQuize() {
  useEffect(() => {
    document.title = "Add Quize - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary ">
        <div className="mx-auto px-5 lg:px-0" style={{ maxWidth: "45%" }}>
          <h4 className="mb-8 text-xl font-bold text-center">Assign Quize</h4>
          <AddQuizeComponents />
        </div>
      </section>
    </>
  );
}
